export const env = {
  name: "STAGING",
  blockchainScanSite: 'https://mumbai.polygonscan.com/tx/',
  errorRedirectUrl: 'https://unblended.it',
  updatePasswordUrl: 'https://id.longwave.studio/user/updatePasswordAuthenticated',
  resetPasswordUrl: 'https://id.longwave.studio/user/%user%/resetPassword',
  appId: '633ed0d5bba5f438c227f73e',
  allowedBEDomains: ['be.unblended.it', 'be-stage.unblended.it'],
}
